/**
 * Will add al static method here
 * @module src/util/commonHelper.ts
 */

export default function paginateData(data: any[], offset: number, limit: number): any[] {
  return data.slice(offset, offset + limit);
}
